module.exports = __webpack_public_path__ + "../resources/images/illustration_access_error-4cb98fdbf779981c87ce004319e5c903.svg";